import { NgModule } from '@angular/core';
import {CuiUserManualComponent} from './user-manual.component';

@NgModule({
  declarations: [
    CuiUserManualComponent
  ],
  exports: [
    CuiUserManualComponent
  ]
})
export class CuiUserManualModule {}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/help/user-manual/user-manual.module.ts